import { apiClient } from "lib/apiClient";
import { TMarketArea, TMarketAreaGeometry } from "features/MarketAreas/types";

export interface IReplaceMarketAreaPayload {
  name: string;
  description: string | null;
  geometry: TMarketAreaGeometry;
}

export const replaceMarketAreaById = async (
  id: string,
  payload: IReplaceMarketAreaPayload
): Promise<TMarketArea> => {
  const response = await apiClient.put<TMarketArea>(
    `/market-areas/${id}`,
    payload
  );

  return response.data;
};
